export function buildRequestUrl(rawUrl, parameters = []) {
  const value = rawUrl.trim();
  if (!value) throw new Error('请输入请求 URL。');

  let url;
  try {
    url = new URL(value);
  } catch {
    throw new Error('URL 格式无效，请输入完整的 http:// 或 https:// 地址。');
  }
  if (!['http:', 'https:'].includes(url.protocol)) {
    throw new Error('仅支持 HTTP 或 HTTPS 地址。');
  }

  for (const parameter of parameters) {
    if (!parameter.enabled || !parameter.key.trim()) continue;
    url.searchParams.append(parameter.key.trim(), parameter.value);
  }
  return url.toString();
}

export function buildRequestHeaders(rows = [], auth = { type: 'none' }) {
  const headers = {};
  for (const row of rows) {
    const key = row.key.trim();
    if (!row.enabled || !key) continue;
    headers[key] = row.value;
  }

  if (auth.type === 'bearer' && auth.token.trim()) {
    setHeader(headers, 'Authorization', `Bearer ${auth.token.trim()}`);
  } else if (auth.type === 'basic') {
    const encoded = encodeBase64(`${auth.username}:${auth.password}`);
    setHeader(headers, 'Authorization', `Basic ${encoded}`);
  }
  return headers;
}

export function buildRequestBody(type, source, headers) {
  if (type === 'none') return undefined;
  if (type === 'json') {
    let value;
    try {
      value = JSON.parse(source);
    } catch (error) {
      throw new Error(`请求体不是有效 JSON：${error.message}`);
    }
    setDefaultHeader(headers, 'Content-Type', 'application/json');
    return JSON.stringify(value);
  }
  if (type === 'form') {
    const body = new URLSearchParams();
    for (const line of source.split('\n')) {
      if (!line.trim()) continue;
      const separator = line.indexOf('=');
      const key = separator < 0 ? line.trim() : line.slice(0, separator).trim();
      const value = separator < 0 ? '' : line.slice(separator + 1).trim();
      if (key) body.append(key, value);
    }
    setDefaultHeader(headers, 'Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
    return body.toString();
  }
  setDefaultHeader(headers, 'Content-Type', 'text/plain;charset=UTF-8');
  return source;
}

export function formatResponseBody(text, contentType = '') {
  if (!text) return '';
  if (contentType.toLowerCase().includes('json')) {
    try {
      return JSON.stringify(JSON.parse(text), null, 2);
    } catch {
      return text;
    }
  }
  return text;
}

function setDefaultHeader(headers, name, value) {
  if (!findHeader(headers, name)) headers[name] = value;
}

function setHeader(headers, name, value) {
  const existing = findHeader(headers, name);
  if (existing) delete headers[existing];
  headers[name] = value;
}

function findHeader(headers, name) {
  return Object.keys(headers).find((key) => key.toLowerCase() === name.toLowerCase());
}

function encodeBase64(value) {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary);
}
